import {useChatKit} from "@openai/chatkit-react";
import axios from "axios";
import {API_DOMAIN} from "../utils/constants";

export const useAIChatKit = () => {

    const {control} = useChatKit({
        api: {
            // Called once to fetch client secret from your Lambda via API Gateway
            async getClientSecret(existing) {

                if (existing) return existing;

                const res = await axios.post(`${API_DOMAIN}/ai/chat_kit`, {}, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });

                const {client_secret} = await res.data;
                return client_secret;
            },
        },
        theme: {
            colorScheme: 'dark',
            radius: 'round',
            density: 'normal',
            color: {
                surface: {
                    background: '#1d2637',
                    foreground: '#111827'
                }
            },
            typography: {
                baseSize: 16
            }
        },
        composer: {
            attachments: {
                enabled: false
            },
            tools: [
                {
                    id: 'search_docs',
                    label: 'Search docs',
                    shortLabel: 'Docs',
                    placeholderOverride: 'Search documentation',
                    icon: 'book-open',
                    pinned: false
                }
                // ...and 1 more tool
            ],
        },
        startScreen: {
            greeting: '',
            prompts: [],
        },
    });
    return {
        control
    }
}